import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#212121',
        secondary: '#EEEEEE',
        accent: '#FF5252',
        primary_text: '#FFFFFF',
        text: '212121',
        secondary_text: '757575',
        divider: 'BDBDBD',
        kazan: '#267885',
        kazan_light: '#7caeb5',
        wrld_background: '#fafafa',
        wrld_title: '#484848',
        wrld_subtitle: '#767676',
        wrld_grey: '#c5c5c5',
        wrld_red: '#ff4a57',
        wrld_green: '#66BB66',
        wrld_black: '#555555',
        wrld_yellow: '#FEE54D',
        wrld_blue: '#00C2E0',
        alert_red: '#EE4747',
        wrld_orange: '#FF7744',
        wrld_purple: '#6A68CD',
        wrld_yellow_orange: '#FFB902',
        wrld_grey_two: '#EBEAEB',
        wrld_red_label: '#ef476f'
      }
    }
  },
  options: {
    customProperties: true
  }
})
